import axios from "./axiosInstance";
import config from "./config";
import { getTenantId, getAuthSource } from "./apiHelpers";

const BASE_URL = config.BASE_URL;

// ==================== MERCHANDISE API ====================

// Create a new merchandise item
export const createMerchandise = async (token, merchandiseData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/store/merchandise`,
      merchandiseData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Get all merchandise items
export const getAllMerchandise = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/store/merchandise`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-tenant-id": getTenantId(),
        "x-auth-source": getAuthSource(),
      },
    });
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Get merchandise item by ID
export const getMerchandiseById = async (token, merchandiseId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/store/merchandise/${merchandiseId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Update merchandise item
export const updateMerchandise = async (token, merchandiseId, merchandiseData) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/store/merchandise/${merchandiseId}`,
      merchandiseData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Delete merchandise item
export const deleteMerchandise = async (token, merchandiseId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/store/merchandise/${merchandiseId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// ==================== EQUIPMENT API ====================

// Create a new equipment item
export const createEquipment = async (token, equipmentData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/store/equipment`,
      equipmentData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Get all equipment items
export const getAllEquipment = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/store/equipment`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-tenant-id": getTenantId(),
        "x-auth-source": getAuthSource(),
      },
    });
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Get all equipment items
export const getSearchEquipment = async (token, searchTerm) => {
  try {
    const response = await axios.get(`${BASE_URL}/store/merchandise/search?query=${searchTerm}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-tenant-id": getTenantId(),
        "x-auth-source": getAuthSource(),
      },
    });
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Get equipment item by ID
export const getEquipmentById = async (token, equipmentId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/store/equipment/${equipmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Update equipment item
export const updateEquipment = async (token, equipmentId, equipmentData) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/store/equipment/${equipmentId}`,
      equipmentData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Delete equipment item
export const deleteEquipment = async (token, equipmentId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/store/equipment/${equipmentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// ==================== PRODUCT VARIANTS API ====================

// Get all variants for a product
export const getProductVariants = async (token, productId, productType) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/store/variants/${productId}?product_type=${productType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Create a new variant
export const createVariant = async (token, variantData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/store/variants`,
      variantData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Update a variant
export const updateVariant = async (token, variantId, variantData) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/store/variants/${variantId}`,
      variantData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// Delete a variant
export const deleteVariant = async (token, variantId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/store/variants/${variantId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

// ==================== AUDIO PRODUCTS API ====================

export const createAudioProduct = async (token, audioProductData) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/store/audio-products`,
      audioProductData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

export const getAllAudioProducts = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/store/audio-products`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "x-tenant-id": getTenantId(),
        "x-auth-source": getAuthSource(),
      },
    });
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

export const getAudioProductById = async (token, audioProductId) => {
  try {
    const response = await axios.get(
      `${BASE_URL}/store/audio-products/${audioProductId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

export const updateAudioProduct = async (token, audioProductId, audioProductData) => {
  try {
    const response = await axios.put(
      `${BASE_URL}/store/audio-products/${audioProductId}`,
      audioProductData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

export const deleteAudioProduct = async (token, audioProductId) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}/store/audio-products/${audioProductId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};

export const uploadAudioFile = async (token, file) => {
  try {
    const formData = new FormData();
    formData.append("audio", file);

    const response = await axios.post(
      `${BASE_URL}/store/audio-products/upload`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
          "x-tenant-id": getTenantId(),
          "x-auth-source": getAuthSource(),
        },
      }
    );
    return response.data;
  } catch (error) {
    return { success: false, error: error.response?.data?.error || error.message };
  }
};
